import React from 'react';
import { Outlet } from 'react-router-dom';
import { Header } from './Header';
import { Footer } from './Footer';
export function Layout() {
  return <div className="min-h-screen flex flex-col bg-white" data-id="element-287">
      <Header data-id="element-288" />
      <main className="flex-grow" data-id="element-289">
        <Outlet data-id="element-290" />
      </main>
      <Footer data-id="element-291" />
    </div>;
}